(function () {
  "use strict";

  /* Shared store lives in lp-wishlist.js (window.LPWishlist), loaded globally. */
  function wl() { return window.LPWishlist; }

  function initCarousel(sectionEl) {
    var wrapper = sectionEl.querySelector("[data-cpc-track-wrapper]");
    var track = sectionEl.querySelector("[data-cpc-track]");
    if (!wrapper || !track) return;
    if (wrapper.dataset.cpcReady === "1") return;
    wrapper.dataset.cpcReady = "1";

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var dragThresh = 5;
    var didDrag = false;
    var preventClickUntilMouseUp = false;

    wrapper.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      if (e.pointerType === "touch") return;
      if (e.target.closest("button, a")) return;

      isDown = true;
      didDrag = false;
      startX = e.clientX;
      startScroll = wrapper.scrollLeft;
      wrapper.classList.add("is-dragging");
      try {
        wrapper.setPointerCapture(e.pointerId);
      } catch (err) {
        /* no-op */
      }
    });

    wrapper.addEventListener("pointermove", function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > dragThresh) {
        didDrag = true;
        preventClickUntilMouseUp = true;
      }
      if (didDrag) {
        wrapper.scrollLeft = startScroll - dx;
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      wrapper.classList.remove("is-dragging");
      try {
        wrapper.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* no-op */
      }
      requestAnimationFrame(function () {
        preventClickUntilMouseUp = false;
      });
    }

    wrapper.addEventListener("pointerup", endDrag);
    wrapper.addEventListener("pointercancel", endDrag);
    wrapper.addEventListener("pointerleave", function (e) {
      if (e.pointerType === "mouse") endDrag(e);
    });

    wrapper.addEventListener(
      "click",
      function (e) {
        if (!preventClickUntilMouseUp) return;
        var link = e.target.closest("a");
        if (!link) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    /* ---- Prev / next buttons ---- */
    var prevBtn = sectionEl.querySelector("[data-cpc-prev]");
    var nextBtn = sectionEl.querySelector("[data-cpc-next]");

    function maxScroll() {
      return wrapper.scrollWidth - wrapper.clientWidth;
    }

    function step() {
      var card = track.querySelector(".cpc-card");
      var cardW = card ? card.getBoundingClientRect().width : wrapper.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      // scroll about a viewport-worth, snapped to whole cards
      var perView = Math.max(1, Math.round(wrapper.clientWidth / (cardW + gap)));
      return perView * (cardW + gap);
    }

    function updateNav() {
      if (!prevBtn || !nextBtn) return;
      var scrollable = maxScroll() > 2;
      prevBtn.hidden = !scrollable;
      nextBtn.hidden = !scrollable;
      if (!scrollable) return;
      prevBtn.disabled = wrapper.scrollLeft <= 1;
      nextBtn.disabled = wrapper.scrollLeft >= maxScroll() - 1;
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", function () {
        wrapper.scrollBy({ left: -step(), behavior: "smooth" });
      });
      nextBtn.addEventListener("click", function () {
        wrapper.scrollBy({ left: step(), behavior: "smooth" });
      });

      var rafId = 0;
      wrapper.addEventListener(
        "scroll",
        function () {
          if (rafId) return;
          rafId = requestAnimationFrame(function () {
            rafId = 0;
            updateNav();
          });
        },
        { passive: true }
      );

      window.addEventListener("resize", updateNav);
      if ("ResizeObserver" in window) {
        new ResizeObserver(updateNav).observe(wrapper);
      }
      // images finishing load can change scrollWidth
      track.querySelectorAll("img").forEach(function (img) {
        if (!img.complete) img.addEventListener("load", updateNav, { once: true });
      });
      updateNav();
      setTimeout(updateNav, 300);
    }
  }

  function initHearts(sectionEl) {
    var hearts = sectionEl.querySelectorAll("[data-cpc-heart]");
    if (!hearts.length || !wl()) return;

    function reflect() {
      sectionEl.querySelectorAll("[data-cpc-heart]").forEach(function (btn) {
        var card = btn.closest(".cpc-card__inner");
        var id = card && card.getAttribute("data-product-id");
        if (id) btn.setAttribute("aria-pressed", wl().has(id) ? "true" : "false");
      });
    }
    reflect();
    if (!sectionEl.dataset.cpcHeartSub) {
      sectionEl.dataset.cpcHeartSub = "1";
      document.addEventListener("lp:wishlist:change", reflect);
    }

    hearts.forEach(function (btn) {
      if (btn.getAttribute("data-cpc-heart-ready") === "1") return;
      btn.setAttribute("data-cpc-heart-ready", "1");
      var card = btn.closest(".cpc-card__inner");
      var productId = card ? card.getAttribute("data-product-id") : null;
      if (!productId) return;

      btn.addEventListener("click", function () {
        var next = wl().toggle(productId, wl().meta(btn));
        btn.setAttribute("aria-pressed", String(next));

        btn.animate(
          [
            { transform: "scale(1)" },
            { transform: "scale(0.82)" },
            { transform: "scale(1.08)" },
            { transform: "scale(1)" },
          ],
          { duration: 320, easing: "ease" }
        );
      });
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll(".custom-product-carousel");
    sections.forEach(function (s) {
      initCarousel(s);
      initHearts(s);
    });
    // `root` may itself be a carousel (e.g. handed a freshly-swapped node)
    if (root && root.matches && root.matches(".custom-product-carousel")) {
      initCarousel(root);
      initHearts(root);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }

  /* Re-init carousels that get injected after page load — e.g. the product-page
     "Recommended products" section, which lazy-loads its markup via
     <product-recommendations>. */
  var reinit = 0;
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var n = mutations[i].addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (
          n.matches &&
          (n.matches(".custom-product-carousel, [data-cpc-track-wrapper]") ||
            n.querySelector(".custom-product-carousel, [data-cpc-track-wrapper]"))
        ) {
          clearTimeout(reinit);
          reinit = setTimeout(function () {
            init();
          }, 30);
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  if (window.Shopify && window.Shopify.theme) {
    document.addEventListener("shopify:section:load", function (e) {
      if (e && e.target) init(e.target);
    });
  }
})();
